import { Box, Checkbox, FormControlLabel, Stack } from "@mui/material";
import { MaterialInventoriesPermission } from "commons/enum/permission";
import { Dayjs } from "dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { DateRange } from "share-components/atomics/date-range";
import { AddButton } from "share-components/mui-wrap/button/action-button";
import { SearchButton } from "share-components/mui-wrap/button/search-button";
import { PageContentContainer } from "share-components/templates/page/page-content-container";
import { PageFilterContainer } from "share-components/templates/page/page-filter-container";
import { AddMaterialGoodsIssue } from "../add-goods-issue/add-goods-issue";
import { MaterialGroupSelectionConnected } from "../shared-components";
import { UpdateMaterialGoodsIssue } from "../update-goods-issue/update-goods-issue";
import { MaterialGoodsIssueTable } from "./material-goods-issue-table";

export const MaterialGoodsIssueList = observer(() => {
  const {
    materialInventoryManagement: {
      materialGoodsIssueStore: {
        setProp,
        pagination,
        getMaterialGoodsIssue,
        openNew,
        openEdit,
        queryParams: {
          dateRangeFilter: {
            fromAsDayJs,
            toAsDayJs,
            setProp: setDateRangeProps,
          },
          code,
          name,
          type,
          barcode,
          showZeroQuantity,
          setProp: setQueryParamProp,
        },
      },
    },
  } = useStores();
  const onSearch = useCallback(async () => {
    pagination.setProp("pageIndex", 0);
    getMaterialGoodsIssue();
  }, [pagination, getMaterialGoodsIssue]);

  const fromDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setDateRangeProps("from", value ? value.toString() : null);
    },
    [setDateRangeProps],
  );

  const toDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setDateRangeProps("to", value ? value.toString() : null);
    },
    [setDateRangeProps],
  );

  const showZeroQuantityHandler = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      setQueryParamProp("showZeroQuantity", checked);
      getMaterialGoodsIssue();
    },
    [getMaterialGoodsIssue, setQueryParamProp],
  );

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="end"
        spacing={4}
      >
        <Stack direction="column" gap={1}>
          <PageFilterContainer>
            <DateRange
              label={"Ngày xuất"}
              fromDate={fromAsDayJs}
              toDate={toAsDayJs}
              onFromDateChanged={fromDateChangedHandler}
              onToDateChanged={toDateChangedHandler}
            ></DateRange>
          </PageFilterContainer>
          <PageFilterContainer>
            <MaterialGroupSelectionConnected
              codeSelected={code}
              typeSelected={type}
              nameSelected={name}
              barcodeSelected={barcode}
              setSelectionProp={setQueryParamProp}
            ></MaterialGroupSelectionConnected>
            <SearchButton asyncAction={onSearch}></SearchButton>
          </PageFilterContainer>
        </Stack>
        <Box flexShrink={0}>
          <AddButton
            accessPermission={[MaterialInventoriesPermission.IssueCreate]}
            onClick={() => {
              setProp("openNew", true);
            }}
          >
            Thêm xuất kho
          </AddButton>
        </Box>
      </Stack>
      <Stack
        direction={"row"}
        justifyContent={"right"}
        sx={{ marginTop: "10px" }}
        spacing={1}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={showZeroQuantity}
              onChange={showZeroQuantityHandler}
            />
          }
          label="Gồm tồn bằng 0"
        />
      </Stack>
      <PageContentContainer sx={{ marginTop: "10px" }}>
        <MaterialGoodsIssueTable></MaterialGoodsIssueTable>
      </PageContentContainer>

      <>
        {openNew && <AddMaterialGoodsIssue></AddMaterialGoodsIssue>}
        {openEdit && <UpdateMaterialGoodsIssue></UpdateMaterialGoodsIssue>}
      </>
    </>
  );
});
